import { render, staticRenderFns } from "./oldManFileSeventh.vue?vue&type=template&id=460bb95f&scoped=true&"
import script from "./oldManFileSeventh.vue?vue&type=script&lang=js&"
export * from "./oldManFileSeventh.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileSeventh.vue?vue&type=style&index=0&id=460bb95f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bb95f",
  null
  
)

export default component.exports